import { Button } from "@mui/material";
import { TrashIcon } from "@phosphor-icons/react/dist/csr/Trash";
import { DataLoader, ErrorContainer, SuccessContainer } from "../DataLoader";
import { GqlError } from "../common/GqlError";
import { ButtonGroup } from "../ui/buttons";
import { DefaultPanel, PanelListDetail } from "../ui/panels";
import { SaveError } from "./IntegrationComponents";
import { Integration, useDismiss, useGetIntegration, useRemoveIntegration, useStartOAuth } from "./IntegrationHooks";
import { UNKNOWN_INTEGRATION } from "./UnknownIntegration";

const ConnectOAuth = ({ type }: { type: string }) => {
  const { errorMessage } = useStartOAuth("integration", type);

  return (
    <DefaultPanel.Container>
      <DefaultPanel.Header>Add Integration</DefaultPanel.Header>
      <DefaultPanel.Body>
        <SaveError errorMessage={errorMessage} />
        Connecting...
      </DefaultPanel.Body>
    </DefaultPanel.Container>
  );
};

const NewIntegrationEditor = ({ type }: { type: string }) => {
  const integration = Integration({ integration_type: type });
  const dismiss = useDismiss();

  return (
    <DefaultPanel.Container>
      <DefaultPanel.Header>
        Add Integration
        <PanelListDetail.PullRight>
          <Button variant="text" onClick={() => dismiss()}>
            <TrashIcon />
            Cancel
          </Button>
        </PanelListDetail.PullRight>
      </DefaultPanel.Header>
      <DefaultPanel.Body id="integrationEditor">
        <integration.meta.editor integration={integration} />
      </DefaultPanel.Body>
    </DefaultPanel.Container>
  );
};

const ExistingIntegrationEditor = ({ id }: { id: string }) => {
  const { integration, loading, error } = useGetIntegration(id);
  const dismiss = useDismiss();
  const [remove] = useRemoveIntegration();

  let title = "Edit Integration";
  let editor = <UNKNOWN_INTEGRATION.editor />;
  if (integration) {
    title = integration.displayName();
    editor = <integration.meta.editor integration={integration} />;
  }

  return (
    <DefaultPanel.Container>
      <DefaultPanel.Header>
        {title}
        <PanelListDetail.PullRight>
          <ButtonGroup>
            <Button variant="text" onClick={() => dismiss()}>
              Close
            </Button>
            <Button color="error" id="removeIntegration" onClick={() => remove(id)}>
              <TrashIcon />
              Remove
            </Button>
          </ButtonGroup>
        </PanelListDetail.PullRight>
      </DefaultPanel.Header>
      <DefaultPanel.Body id="integrationEditor">
        <DataLoader loading={loading} error={error} success={integration !== undefined}>
          <ErrorContainer>
            <GqlError error={error} />
          </ErrorContainer>
          <SuccessContainer>{editor}</SuccessContainer>
        </DataLoader>
      </DefaultPanel.Body>
    </DefaultPanel.Container>
  );
};

const IntegrationEditor = {
  New: NewIntegrationEditor,
  Existing: ExistingIntegrationEditor,
  Connect: ConnectOAuth,
};

export { IntegrationEditor };
